import React from 'react';
import Select from 'react-select'
import ColumnNew from '../components/ColumnNew';
import Footer from '../components/footer';
import { createGlobalStyle } from 'styled-components';
import Header from '../menu/header2'




const services= () => (
<div>
<Header></Header>
  <section style={{paddingTop:'5em',backgroundColor:'#e5dfca'}}>
    <div style={{backgroundColor:'#e5dfca'}}>
      <div className='container'>
        <div className='row m-10-hor'>
          <div className='col-12'>
            <h1 className='text-center' style={{color:'black'}}>About Us</h1>
            <br></br>
            <h2 style={{color:'black'}}>We are a small studio specializing in building end-to end solutions for a variety of industries incorporating emerging technologies like AI and web3. </h2>
            <br></br>
            

            <h2 style={{color:'black'}}>We also take care of the branding, content, programming and testing so you can iterate quickly. </h2>

            <hr style={{borderBottom: '10px solid black'}}></hr>
            <br></br>
            <h2 style={{color:'black'}}>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>



  <Footer />
</div>

);
export default services;